'use strict'
module.exports = {
	BASE_API: '"https://checkup.anyoujc.cn/Api_Client"',
  	NODE_ENV: '"production"'
}



//////////////////
// WEBPACK FOOTER
// ./config/dev.env.js
// module id = dhIU
// module chunks = 4